<template>
    <div class="auth flex-column">
        <transition name="slide-left" >
			<router-view class="child-view" /> 
		</transition>
    </div>
</template>
<script>
export default {
    name: "auth",
}
</script>

